import { Container } from 'pixi.js';
import VisualComponent from './VisualComponent.js';
import { logger } from '@orbital/slot-lib';

class Ui extends Container {
	vcs = [];
	constructor() {
		super();
		this.vcs = [];
		this.sortableChildren = true;
	}

	addView(obj) {
		obj.handler = this.clickHandler;
		var vc = new VisualComponent(obj);
		if (!window.isMobile || window.isTablet) {
			vc.position.set(obj.position.x, obj.position.y);
		} else {
			vc.position.set(0, 0);
		}
		if (obj.child) {
			this.addChild(vc);
		} else {
			this.addChildAt(vc, 0);
		}
		if (obj.zIndex) {
			vc.zIndex = obj.zIndex;
		}
		let name = obj.name;
		this[name] = vc;
		this.vcs.push(vc);
		this.resize(window.CurrentSize.w, window.CurrentSize.h);
		logger.log(
			`%c${name} component was created`,
			'color: pink; padding: 10px;'
		);
	}

	removeView(obj) {
		var conf = obj;
		if (obj.config) {
			conf = obj.config;
		}
		this.removeChild(obj);
		delete this[conf.name];
		logger.log(
			`%c${conf.name} component was deleted`,
			'color: #fcba03; padding: 10px;'
		);
		var index = this.vcs.findIndex((item) => {
			return item.config.name === conf.name;
		});
		if (index > -1) {
			this.vcs.splice(index, 1);
		}
	}

	resize(w, h) {
		if (this.gridController) {
			this.gridController.resize(w, h);
			clearTimeout(this.timeeout);
			this.timeeout = setTimeout(() => {
				this.gridController.resize(w, h);
			}, 1000);
		}
		for (let i = 0; i < this.vcs.length; i++) {
			this.vcs[i].resize(w, h);
			clearTimeout(this.timeout_1);
			this.timeout_1 = setTimeout(() => {
				if (this.vcs[i] !== undefined) {
					this.vcs[i].resize(w, h);
				}
			}, 1000);
		}
	}
}

export default Ui;
